/**
 * Sorts version directories in descending order and prepends the "current" option.
 * Returns the full list of selectable version options.
 */
export function buildVersionOptions(versions: string[]): string[] {
  const sorted = [...versions].sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));
  return ['current', ...sorted];
}
